import styled from '@emotion/styled'

import { SUB_COLOR } from '@/constants/colors'

const TICKER_BG_COLOR = '#4c4d52'
const AMOUNT_COLOR = '#ffd766'
const TEXT_DIVIDER_COLOR = '#85878e'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const TickerPill = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 20px;
  background-color: ${TICKER_BG_COLOR};
  border-radius: 9999px;
  white-space: nowrap;
`

export const WinnerInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`

export const WinnerName = styled.span`
  color: white;
`

export const WinnerAmount = styled.span`
  color: ${AMOUNT_COLOR};
`

export const WinnerLabel = styled.span`
  color: white;
`

export const TickerDivider = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${TEXT_DIVIDER_COLOR};
`

export const TimeText = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${SUB_COLOR};
`
